import React from 'react';
import {Box, Checkbox, HStack, Heading, Text} from 'native-base';

const DEFAULT_VALUE = 'YES';

interface CalculatorOptionsProps {
  value: string;
  label: string;
  hideCheck?: boolean;
  checked?: boolean;
  help?: string;
  onChange?: (value: boolean) => void;
}

const CalculatorOptions = ({
  onChange,
  label,
  value,
  hideCheck,
  checked,
  help,
}: CalculatorOptionsProps) => {
  const [isChecked, setIsChecked] = React.useState(checked);

  const defaultWidth = '60%';

  const handleChangeCheckbox = (change: any) => {
    setIsChecked(change);
    if (onChange) {
      onChange(change);
    }
  };

  const showCheck = () => {
    if (hideCheck == null) {
      return true;
    }
    return hideCheck ? true : false;
  };

  return (
    <>
      {!showCheck() && (
        <>
          <HStack justifyContent={'space-between'} width={'100%'} marginTop={2}>
            <Heading
              fontSize={'lg'}
              fontWeight={'bold'}
              color="#06355E"
              alignSelf={'center'}
              marginLeft={7}
              flexWrap={'wrap'}
              maxWidth={100}>
              {label}
            </Heading>
            <Box
              borderColor={'#C2C2CB'}
              backgroundColor={'#F3F9FF'}
              borderWidth={1}
              width={defaultWidth}
              height={35}
              alignItems={'flex-end'}
              marginRight={1}
              borderRadius={10}
              padding={1}>
              <Heading
                fontSize={'lg'}
                fontWeight={'normal'}
                color={'#06355E'}
                marginRight={2}>
                {value}
              </Heading>
            </Box>
          </HStack>
          {help && (
            <Text
              width={'100%'}
              color={'orange.400'}
              textAlign={'right'}
              paddingRight={2}>
              {help}
            </Text>
          )}
        </>
      )}

      {showCheck() && (
        <>
          <Checkbox
            {...{isChecked}}
            value={DEFAULT_VALUE}
            onChange={change => handleChangeCheckbox(change)}
            marginTop={2}>
            <HStack justifyContent={'space-between'} width={'100%'}>
              <Heading
                fontSize={'lg'}
                fontWeight={'bold'}
                color="#06355E"
                alignSelf={'center'}>
                {label}
              </Heading>
              <Box
                borderColor={'#C2C2CB'}
                backgroundColor={'#F3F9FF'}
                borderWidth={1}
                width={defaultWidth}
                height={35}
                alignItems={'flex-end'}
                marginRight={8}
                borderRadius={10}
                padding={1}>
                <Heading
                  fontSize={'lg'}
                  fontWeight={'normal'}
                  color={'#06355E'}
                  marginRight={2}>
                  {value}
                </Heading>
              </Box>
            </HStack>
          </Checkbox>
          {help && (
            <Text
              width={'100%'}
              color={'orange.400'}
              textAlign={'right'}
              paddingRight={2}>
              {help}
            </Text>
          )}
        </>
      )}
    </>
  );
};

export default CalculatorOptions;
